import React, {useState} from 'react'
import styled from 'styled-components'
import {navigate} from 'gatsby'

import ButtonLink from "../../library/ButtonLink";
import ModalSafeRecreation from "./modal-safe-recreation/ModalSafeRecreation";
import ModalStayUpdated from "../../library/ModalStayUpdated";

const Applications = () => {
    const [modalState, setModalState] = useState(false)
    const [text, setText] = useState(0)

    const text1 = {
        'title': "Therapeutics",
        'description': "Medad Technology’s Nebulizer works on the principles of piezoelectric effect and ultrasound cavitation. Through a patented algorithm designed to optimize the cavitation bubble, we can restrict the size of particles created to 1-3",
        'micro': "µ",
        'description2': "m. This allows for narrow particle distribution in the propagation of the mist, ensuring an extremely potent solution delivery to users, directly to the alveoli, delivered from the compact, pocket-sized device. The product will undergo clinical trials soon."
    }
    const text2 = {
        'title': 'Safe Recreation',
        'description': "Medad Technology has solved the longstanding challenge of removing the need for heat during delivery of inhaled recreational liquids, creating a safer, more efficient, and advanced solution for users. The new mechanism maximizes the benefit-to-risk ratio by eliminating harmful emissions.",
    }
    const text3 = {
        'title': 'Smoking Cessation',
        'description': "The ultimate aim of Medad Technology is not only to reduce the harm caused by smoking or vaping, but to help people rid themselves of smoking completely. Our research into smoking cessation is developing new ways of controlling nicotine intake through precise delivery measurement. We are developing partnerships with experts researching how to assist in the mental and physical support needed to quit smoking.",
    }

    return (
        <ApplicationsStyle modalState>
            {modalState &&
                <ModalStayUpdated text={'Stay updated'} modalState={modalState}
                                     setModalState={setModalState}/>
            }
            <TextWrapper>
                <H2>APPLICATIONS</H2>
            </TextWrapper>
            <CategoriesList>
                <Category>
                    <H3>{text1.title}</H3>
                    <P>{text1.description} <span>{text1.micro}</span>{text1.description2} </P>
                    <LinkStyle>
                        <ButtonLink type={'button'} label={'Stay tuned'} onClick={() => {
                            setModalState(true)
                            setText(1)
                        }}/>
                    </LinkStyle>
                </Category>
                <Category>
                    <H3>{text2.title}</H3>
                    <P>{text2.description}</P>
                    <LinkStyle>
                        <ButtonLink type={'button'} label={'Stay tuned'} onClick={() => {
                            setModalState(true)
                            setText(2)
                        }}/>
                    </LinkStyle>
                </Category>
                <Category>
                    <H3>{text3.title}</H3>
                    <P>{text3.description}</P>
                    <LinkStyle>
                        <ButtonLink type={'button'} label={'Stay tuned'} onClick={() => {
                            setModalState(true)
                            setText(3)
                        }}/>
                    </LinkStyle>
                </Category>
            </CategoriesList>
        </ApplicationsStyle>
    )
}

export default Applications

const ApplicationsStyle = styled.div`
  min-height: 100vh;
  padding: 5.7rem 12rem 8.9rem 12rem;
  background-color: #E7F0F3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${({theme}) => theme.breakpoints.mobile} {
    padding: 4rem 2.4rem;
  }
  @media ${({theme}) => theme.breakpoints.small_height} {
    padding: 5.7rem 15vw 8.9rem 15vw;
  }
  &::-webkit-scrollbar {
    display: none;
    overflow-y: none;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`

const CategoriesList = styled.div`
  margin-top: 9.6rem;
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 11.6rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3.5rem;
    margin: 0;
  }
`

const Category = styled.div`
  min-width: 22.4rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  span {
    font-size: 2rem;
  }
`

const H2 = styled.h2`
  font-size: 3.2rem;
  line-height: 5.8rem;
  color: #0C2637;
  justify-self: center;
  @media ${({theme}) => theme.breakpoints.mobile} {
    // display: none;
    margin-bottom: 4rem;
    font-size: 2rem;
    line-height: 2.7rem;
  }
`

const H3 = styled.h3`
  font-family: Sequel75;
  font-size: 2rem;
  line-height: 2.7rem;
  color: #3B869D;
`

const P = styled.p`
  margin-top: 2rem;
  color: #0C2637;
  font-family: Sequel45;
  font-size: 1.6rem;
  line-height: 2.2rem;
`

const LinkStyle = styled.a`
`
